import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { BusinessComponent } from './business.component';
import { BusinessRoutingModule } from './business-routing.module';
import { NgZorroAntdModule } from 'ng-zorro-antd';
//module
import {
  BusinessInfoModule,
  ChatModule,
  DashboardModule,
  DistributorsModule,
  InteractionsModule,
  ProductsModule,
  ShopsModule,
  MediaModule,
  CustomersModule,
  LogCallModule
} from './';
import { BusinessCodesModule } from './business-codes/business-codes.module';
import { AccountInfoModule } from './account-info/account-info.module';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { SharedModule } from 'src/app/shared';
import { BusinesstDirective } from 'src/app/business/business.directive';
import {LoyaltyModule} from "./loyalty/loyalty.module";
import {GuideModule} from "./guide/guide.module";
import {QRCodeModule} from 'angularx-qrcode';

@NgModule({
    declarations: [BusinessComponent, BusinesstDirective],
  imports: [
    CommonModule,
    BusinessRoutingModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    //module
    BusinessInfoModule,
    ChatModule,
    DashboardModule,
    DistributorsModule,
    InteractionsModule,
    ProductsModule,
    BusinessCodesModule,
    AccountInfoModule,
    NzMenuModule,
    NzModalModule,
    NzCardModule,
    NzUploadModule,
    ReactiveFormsModule,
    SharedModule,
    ShopsModule,
    MediaModule,
    CustomersModule,
    LogCallModule,
    LoyaltyModule,
    GuideModule,
    QRCodeModule,
    FormsModule
  ],
    exports: [
    ]
})
export class BusinessModule { }

